'use client';

const defaultProps = {
  roundness: "sm",
  emphasis: "high"
};
export {
  defaultProps
};
